import { c as _c } from "react/compiler-runtime";
import AddIcon from '@mui/icons-material/Add';
import { ButtonProps, Button } from './Button';
export const Add: React.FC<ButtonProps> = t0 => {
  const $ = _c(3);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AddIcon />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = text || "Add";
  let t3;
  if ($[1] !== t2) {
    t3 = <Button startIcon={t1} text={t2} />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};